import React from "react";
// import CreateFile from "../actions/CreateFile";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { makeStyles } from "@material-ui/styles";
import { useDropzone } from "react-dropzone";
import ConfirmToast from "components/ConfirmToast";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Snackbar from "@material-ui/core/Snackbar";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  changeCurFolderByContent,
  createMultiFile,
} from "../../slice/libraryThunks";
import {
  addFilesWithCheck,
  checkAllVersions,
  checkAllVersionsNull,
  checkFilesForUpload,
  selUploadList,
  selUploadStatus,
  setFilesToUpload,
  stopUpload,
} from "../../slice/librarySlice";
// import Uploader from "./Uploader";
import { selContent } from "../../slice/librarySlice";
import AfterUploadModal from "../UIs/AfterUploadModal";
import { DONEUPLOAD, LIBRARY_ACCEPTED_FILES, ONCHECK, ONUPLOAd } from "../../slice/constants";
// import UploaderBox from "../UploaderBox/backup";

import * as R from "ramda";

const useStyles = makeStyles({
  icon: {
    color: "red",
    width: 24,
    height: 24,
    cursor: "pointer",
    marginLeft: -25,
  },
});

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginTop: 16,
};

const checkPropInArrOfObjects = (prop, arr, value) => {
  return R.find(R.propEq(prop, value))(arr) ? true : false;
};

export default function FilesModal(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const { modal, closeModal, openModal } = props;

  const { getRootProps, getInputProps } = useDropzone({
    accept: LIBRARY_ACCEPTED_FILES,
    onDrop: (acceptedFiles) => {
      const files = acceptedFiles.map((file) => {
        return Object.assign(file, {
          preview: URL.createObjectURL(file),
        });
      });
      return dispatch(addFilesWithCheck(files));
    },
  });
  const handleOpenSnackbar = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  function minimizeModal() {
    // minimize modal while uploading
    closeModal("file");
  }

  const uploadStutus = useSelector(selUploadStatus);

  return (
    <React.Fragment>
      <Modal className={classes.modal} size="lg" isOpen={modal}>
        <ModalHeader toggle={minimizeModal}>Upload New File</ModalHeader>
        <ModalBody>
          <div className="dropzone-card">
            {uploadStutus === ONCHECK && (
              <div className="dropzone">
                <div {...getRootProps({ className: "dropzone-file-btn" })}>
                  <input {...getInputProps()} />
                  <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
              </div>
            )}
            <div className="dropzone-content" style={thumbsContainer}>
              <AfterUploadModal />
              {/* {Thumbs} */}
            </div>
          </div>
          {/* <Uploader current={current} /> */}
        </ModalBody>
        {/* <ModalFooter>
          <Button outline color="primary" onClick={closeToggle}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleUploadFile}>
            Upload
          </Button>
        </ModalFooter> */}
        <UploadButtons close={closeModal} />
      </Modal>
      {/* <UploaderBox /> */}
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={!modal && !(uploadStutus === ONCHECK)}
        autoHideDuration={6000}
        onClose={handleClose}
        message={
          uploadStutus === DONEUPLOAD
            ? "Upload Finished"
            : "Your files are uploading!"
        }
        action={
          <React.Fragment>
            <Button
              color="primary"
              className="mt-1"
              size="small"
              onClick={() => openModal("file")}
            >
              View
            </Button>
          </React.Fragment>
        }
      />
    </React.Fragment>
  );
}

function UploadButtons(props) {
  const dispatch = useDispatch();
  const { current } = useSelector(selContent);
  const uploadStutus = useSelector(selUploadStatus);
  const uploadList = useSelector(selUploadList);
  const { close } = props;

  function handleUploadFile() {
    const valid = dispatch(checkAllVersions());

    const nullValidations = dispatch(checkAllVersionsNull());
    if (!nullValidations) return "";
    if (!valid) return toast.warn("Some files need to be checked");

    dispatch(createMultiFile(current));
    // dispatch(checkFilesForUpload());
  }

  function closeToggle() {
    toast.info(
      <ConfirmToast
        message="Are you sure to cancel upload?"
        confirm={cacelUpload}
      />
    );
  }

  async function cacelUpload() {
    // setFiles([]);
    await dispatch(stopUpload());
    // dispatch(setFilesToUpload([]));
    dispatch(changeCurFolderByContent(current, "current"));
    close("file");
  }

  switch (uploadStutus) {
    case ONCHECK:
      return (
        <ModalFooter>
          {uploadList.length !== 0 && (
            <>
              <Button outline color="primary" onClick={closeToggle}>
                Cancel
              </Button>

              <Button color="primary" onClick={handleUploadFile}>
                upload
              </Button>
            </>
          )}
        </ModalFooter>
      );
    case ONUPLOAd:
      return (
        <ModalFooter>
          <Button outline color="primary" onClick={closeToggle}>
            Cancel
          </Button>
        </ModalFooter>
      );

    case DONEUPLOAD:
      return (
        <ModalFooter>
          <Button outline color="primary" onClick={cacelUpload}>
            close
          </Button>
        </ModalFooter>
      );

    default:
      return (
        <ModalFooter>
          <Button outline color="primary" onClick={closeToggle}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleUploadFile}>
            upload
          </Button>
        </ModalFooter>
      );
  }
}
